import React from "react";
import "./EnterpriseAI.css";
import Button from "../../components/Button/Button";
import { Container, Row, Col, Card } from "react-bootstrap";
import enterprise_img_2 from "../../assets/images/enterprise_img_2.jpg";
import OfferingsTabs from "../../components/OfferingsTabs/OfferingsTabs";
import "bootstrap/dist/css/bootstrap.min.css";
import { enterprise_caseStudies } from "../../StaticData/caseStudiesData";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import {
  FaAngleLeft,
  FaAngleRight,
  FaArrowLeft,
  FaArrowRight,
  FaArrowUp,
} from "react-icons/fa";
import { Helmet } from "react-helmet";

const backgroundGradients = [
  "linear-gradient(to bottom, #1B083E, #47228B)", // Orange gradient
  "linear-gradient(to bottom, #410248, #600B63)", // Light blue gradient
  "linear-gradient(to bottom, #1B083E, #47228B)", // Green gradient
];
const EnterpriseAI = () => {
  return (
    <div className="enterpriseAI-page">
          <Helmet>
        <title>Enterprise AI Solutions | Idexcel</title>
        <meta
          name="description"
          content="Unlock the power of Enterprise AI solutions to drive innovation, automate processes, and enhance decision-making. Transform your business with AI today—get started now!"
        />
      </Helmet>
      {/* //banner section  */}
      <section className="banner-section">
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <div className="banner-overlay mt-5">
                <h1 className="banner-title">
                  The Intelligence Layer <br></br> for Autonomous <br></br>{" "}
                  Growth
                </h1>
                <Button className="banner-button" size="large" color="banner">
                  <a href="/contact-us" className="text-white">
                    Contact Us
                  </a>
                  <FaArrowUp className="explore-arrow" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* section 2 */}
      <Container fluid className="py-5 px-5">
        <section className="image-text-section">
          <Container style={{ backgroundColor: "#F1F8FF" }}>
            <Row className="custom-flex justify-content-center align-items-center">
              {/* Left Side: Image */}
              <Col
                lg={5}
                md={6}
                sm={12}
                className="image-box align-items-center"
              >
                <img
                  src={enterprise_img_2}
                  alt="Tech Image"
                  className="img-fluid"
                />
              </Col>

              {/* Right Side: Content */}
              <Col lg={6} md={6} sm={12} className="content-box">
                <h1 className="section-title">
                  Is Your Enterprise Truly Leveraging AI?
                </h1>
                <p className="fs-5">
                  Move beyond automation—enable intelligent decisions, optimize
                  processes, and personalize at scale. Seamlessly integrate Al
                  to unlock insights, scale agents, and drive measurable growth.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </Container>

      <OfferingsTabs />

      {/* section 2 */}

      {/* <Container className="my-5">
        <h1 className="text-center mb-4 section-title">
          Customer <span className="textgrad">Success</span> Stories
        </h1>
        <Row>
          {caseStudies.map((study) => (
            <Col key={study.id} xs={12} md={6} className="mb-4">
              <div className="case-study-wrapper">
                <Card className="h-100  case-study-box">
                  <a
                    href={study.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Img
                      variant="top"
                      src={study.image}
                      alt={study.title}
                    />
                  </a>
                  <Card.Body className="case-study-body border-bottom position-relative">
                    <a
                      href={study.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="case-study-title"
                    >
                      <Card.Title>
                        <h2>{study.title}</h2>
                      </Card.Title>
                    </a>
                    <Card.Text>
                      <p>{study.description}</p>
                    </Card.Text>

                    <a
                      className="case-study-read position-absolute"
                     
                      variant="primary"
                      href={study.link}
                    >
                      Read More{" "}
                      <i
                        className="bi bi-arrow-up-right"
                        style={{ fontSize: "12px" }}
                      ></i>
                    </a>
                   
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>

      </Container> */}

      <section className="py-5 mt-5" style={{ backgroundColor: "#F1F8FF" }}>
        {/* <Container fluid> */}
        <Container>
          <h1 className="text-center mb-5 section-title">
            Customer Success Stories
          </h1>
          <Row className="case-study-row d-flex justify-content-center flex-row">
            {enterprise_caseStudies.map((study, index) => (
              <Col key={study.id} xs={12} md={6} lg={3} className="mb-4">
                <div
                  className={`case-study-card position-relative card-${study.id}`}
                  style={{ background: backgroundGradients[index % backgroundGradients.length] }}
                >
                  <div className="case-study-image">
                    <img
                      src={study.image}
                      alt={study.title}
                      className="img-fluid"
                    />
                    <div className="case-study-title-overlay p-3">
                      <h2 className="case-study-title text-white">
                        {study.title}
                      </h2>
                    </div>
                  </div>
                  <div className="case-study-description mt-3">
                    <p style={{color:"white"}}>{study.description}</p>
                    <a href={study.link} className="desc-btn" target="_blank">
                      Expand <FaAngleRight />
                    </a>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          {/* </Container> */}
        </Container>
      </section>

      <GetInTouch heading="Smarter AI for Smarter Enterprises" headingColMd={9} buttonColMd={3} />
    </div>
  );
};

export default EnterpriseAI;
